module.exports = __webpack_public_path__ + "img/1543596487.afade4a3.jpg";